import { render, staticRenderFns } from "./StepBackButton.vue?vue&type=template&id=a821148c&scoped=true&"
import script from "./StepBackButton.vue?vue&type=script&lang=js&"
export * from "./StepBackButton.vue?vue&type=script&lang=js&"
import style0 from "./StepBackButton.vue?vue&type=style&index=0&id=a821148c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a821148c",
  null
  
)

export default component.exports